export const SettingsPage = () => <div>SettingsPage</div>

// TODO: First option in settings: redirect to list on open the app.
